/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".outage-card[_ngcontent-%COMP%]{padding-top:100px;display:flex;flex-wrap:nowrap;justify-content:space-evenly;align-content:space-around}"];
export { styles as styles };

